import { render } from "./SoB2.vue?vue&type=template&id=6526da34"
import script from "./SoB2.vue?vue&type=script&lang=js"
export * from "./SoB2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/tcp/SoB2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6526da34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6526da34', __exports__)) {
    api.reload('6526da34', __exports__)
  }
  
  module.hot.accept("./SoB2.vue?vue&type=template&id=6526da34", () => {
    api.rerender('6526da34', render)
  })

}


export default __exports__